import React, { useState } from "react";
import News from "../components/News";
import { useFirebase } from "../providers/firebase";
import { useAuthentication } from "../providers/authentication";
import PopupModal from "../components/PopupModal"; // Import modal for editing

const HomePage = () => {
  const { homeAbout, homeVision, homeObjective, editSection, deleteSection, addSection } = useFirebase();
  const { user } = useAuthentication();

  const [isModalVisible, setModalVisible] = useState(false);
  const [currentContent, setCurrentContent] = useState("");
  const [currentSection, setCurrentSection] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [isAdding, setIsAdding] = useState(false); // To differentiate add/edit actions

  // Show modal and set content to edit or add
  const handleEdit = (section, content, index) => {
    setCurrentSection(section);
    setCurrentContent(content);
    setCurrentIndex(index);
    setIsAdding(false);
    setModalVisible(true);
  };

  const handleAdd = (section) => {
    setCurrentSection(section);
    setCurrentContent("");
    setCurrentIndex(null);
    setIsAdding(true);
    setModalVisible(true);
  };

  // Handle delete action
  const handleDelete = (section, index) => {
    deleteSection(section, index)
      .then(() => window.location.reload())
      .catch(err => console.error("Error deleting content:", err));
  };

  // Submit content for add or edit
  // Submit content for add or edit
const handleSubmit = (updatedContent) => {
  if (isAdding) {
    addSection(currentSection, updatedContent)
      .then(() => {
        setModalVisible(false);
        window.location.reload();
      })
      .catch(err => console.error("Error adding content:", err));
  } else {
    editSection(currentSection, currentIndex, updatedContent)
      .then(() => {
        setModalVisible(false);
        window.location.reload();
      })
      .catch(err => console.error("Error editing content:", err));
  }
};

  return (
    <>
      <div className="home-heading-bg"></div>
      <div className="home-container">
        <div className="home-heading">
          <div className="home-big-heading">
            <div>
              <span className="highlight">VI</span>sual{" "}
              <span className="highlight"> S</span>urveillance
            </div>
            <div>
              using <span className="highlight"> M</span>L and{" "}
              <span className="highlight"> A</span>I (VISMA)
            </div>
          </div>
          <div className="home-small-heading">
            <div className="home-line-1">
              Department of Computer Science and Engineering
            </div>
            <div className="home-line-2">
              Indian Institute of Technology, Bhubaneswar
            </div>
          </div>
        </div>

        <div className="home-body">
          <div className="home-left-container">
            <div className="home-left-title">
              <div className="home-black-line"></div>
              <div className="title">
                About <span className="highlight">VI</span>sual{" "}
                <span className="highlight"> S</span>urveillance using{" "}
                <span className="highlight"> M</span>L and{" "}
                <span className="highlight"> A</span>I (VISMA)
              </div>
              <div className="home-black-line"></div>
            </div>

            <div className="home-about-section">
              {homeAbout && homeAbout.map((item, idx) => (
                <div key={idx}>
                  <p>{item}</p>
                  {user && (
                    <div className="actions">
                      <button onClick={() => handleEdit("homeAbout", item, idx)}>Edit</button>
                      <button onClick={() => handleDelete("homeAbout", idx)}>Delete</button>
                    </div>
                  )}
                </div>
              ))}
              {user && (
                <button onClick={() => handleAdd("homeAbout")}>Add Paragraph</button>
              )}
            </div>

            <div className="home-vision-section">
              <h2>Vision:</h2>
              {homeVision && homeVision.map((item, idx) => (
                <div key={idx}>
                  <p>{item}</p>
                  {user && (
                    <div className="actions">
                      <button onClick={() => handleEdit("homeVision", item, idx)}>Edit</button>
                      <button onClick={() => handleDelete("homeVision", idx)}>Delete</button>
                    </div>
                  )}
                </div>
              ))}
              {user && (
                <button onClick={() => handleAdd("homeVision")}>Add Paragraph</button>
              )}
            </div>

            <div className="home-objectives-section">
              <h2>Objectives:</h2>
              <ol>
                {homeObjective && homeObjective.map((item, idx) => (
                  <li key={idx}>
                    {item}
                    {user && (
                      <div className="actions">
                        <button onClick={() => handleEdit("homeObjective", item, idx)}>Edit</button>
                        <button onClick={() => handleDelete("homeObjective", idx)}>Delete</button>
                      </div>
                    )}
                  </li>
                ))}
              </ol>
              {user && (
                <button onClick={() => handleAdd("homeObjective")}>Add Objective</button>
              )}
            </div>
          </div>

          <div className="home-right-container">
            <div className="home-news-container">
              <h2>News</h2>
              <div className="home-news">
                <News />
              </div>
            </div>
          </div>
        </div>

        <div className="copyright-bar">
          (c) All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
        </div>
      </div>

      <PopupModal
        show={isModalVisible}
        onClose={() => setModalVisible(false)}
        onSubmit={handleSubmit}
        defaultValue={currentContent}
      />
    </>
  );
};

export default HomePage;